import { Component, Input } from '@angular/core';
import { LeftTrackComponent } from '../../tracking/left-track/left-track.component';

@Component({
    selector: 'app-left-report',
    templateUrl: './left-report.component.html',
    styleUrls: ['./left-report.component.css'],
    standalone: false
})
export class LeftReportComponent extends LeftTrackComponent {
    @Input() showDeviceMenu: boolean = true;

}
